import LinkInBioPage from "@/components/LinkInBioPage";
import ctaBackground from "@/assets/cta-background.png";
import { trackCtaClick, trackVendorApplyClick } from "@/lib/analytics";

const Tickets = () => {
  return (
    <LinkInBioPage
      headline="Next event coming soon"
      subtext="Our next Sole to Sole date hasn't been announced yet — get on the list to be first in line."
      primaryCta={{
        label: "Notify Me When Tickets Drop",
        href: "/#notify",
        caption: "We'll text + email you the second it's live",
        onClick: () => trackCtaClick("notify_me_tickets_bio", "/#notify"),
      }}
      secondaryCta={{
        label: "Apply as a Vendor",
        href: "/apply",
        onClick: () => trackVendorApplyClick("tickets_link_in_bio"),
      }}
      sectionLabel="Explore"
      backgroundImage={ctaBackground}
    />
  );
};

export default Tickets;
